module.exports = "<app-header></app-header>\n<router-outlet></router-outlet>\n<app-footer></app-footer>"


//////////////////
// WEBPACK FOOTER
// /Users/eduar.doramirez/developer/code/edd/ceramicamx/web/cmx-catalog/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main